module.exports = __webpack_public_path__ + "media/img/help_center/Institution_Scholarship_Creation_07-908edd3f3b48b2797ed7e54997dd9c96.jpg";